function a(t, n) {
  let { target: e } = t;
  for (; e; ) {
    if (e.dataset && e.dataset[n] !== void 0)
      return !0;
    e = e.parentElement;
  }
  return !1;
}
export {
  a as happensIn
};
